import { FC } from "react"
import { useNavigate } from "react-router"
import CardSizeSetting, { CardType } from "./CardSizeSetting"
import LocationToggle from "./LocationToggle"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"
import { Icon } from "@/components/shared/Icon"
import { PageRoutes } from "@/constants/routes"
import "./index.scss"

const SECTION_SIZE = { xs: 12, sm: 6, lg: 3 }

const Preferences: FC = () => {
   const navigate = useNavigate()
   const onClickButton = () => {
      navigate(PageRoutes.FLOOR_OVERVIEW)
   }

   return (
      <Grid
         direction="column"
         flexWrap="nowrap"
         className="preferences"
      >
         <GridItem size={12}>
            <div
               className="preferences__back-button"
               onClick={onClickButton}
            >
               <Icon
                  size="16"
                  name="arrowLeft"
                  className="preferences__back-button-icon"
               />
               <span>Go back to Floor Overview</span>
            </div>
            <h1 className="preferences__title">Preferences</h1>
         </GridItem>
         <GridItem size={SECTION_SIZE}>
            <LocationToggle />
         </GridItem>
         <GridItem size={SECTION_SIZE}>
            <CardSizeSetting cardType={CardType.CELL} />
         </GridItem>
         <GridItem size={SECTION_SIZE}>
            <CardSizeSetting cardType={CardType.INMATE} />
         </GridItem>
      </Grid>
   )
}

export default Preferences
